import moment from 'moment-timezone';

export const getInitials = (name) => name
  .split(' ')
  .filter(Boolean)
  .slice(0, 2)
  .map((word) => word[0].toUpperCase())
  .join('');

export const formatAuthorNames = (authors) => {
  if (authors.length <= 1) {
    return authors[0] || '';
  }
  return `${authors.slice(0, -1).join(', ')} e ${authors[authors.length - 1]}`;
};

export const formatVersion = (version) => `v${String(version).replace(/^v/i, '')}`;

// Quantas versões o botão "Gerar do Jira" cria por clique (igual a SYNC_BATCH_SIZE
// em sync_changelog_from_jira.js das functions). A resposta traz `batchSize`, usado
// no aviso do fim da rodada; aqui é o valor mostrado antes de chamar.
export const JIRA_SYNC_BATCH_SIZE = 10;

// Chave RTDB não aceita ".": "1.33.4" vira "1_33_4" (nó changelogSync/ignoredVersions).
export const getVersionSyncKey = (version) => String(version).replace(/^v/i, '').replace(/\./g, '_');

// Chave usada nos mapas de likes (contagem e likes do usuário) e nos nós do RTDB.
export const getLikeKey = (entryKey, itemId) => `${entryKey}/${itemId}`;

export const getItemId = (item, index) => item.id || String(index);

export const ITEM_TYPE_META = {
  new: { label: 'Novidade', color: 'green' },
  improvement: { label: 'Melhoria', color: 'cyan' },
  fix: { label: 'Correção', color: 'red' },
};

export const normalizeChangelogEntry = (key, entry) => {
  const items = entry.items
    ? entry.items.map((item) => ({
      id: item.id || null,
      title: item.title,
      description: item.description || null,
      area: item.area || null,
      type: item.type || null,
    }))
    : (entry.changes || []).map((change) => ({
      id: null,
      title: change.title,
      description: [change.subTitle, change.description].filter(Boolean).join(' — ') || null,
      area: null,
      type: null,
    }));

  let authorName = null;
  if (typeof entry.author === 'string') {
    authorName = entry.author;
  } else if (entry.author?.name) {
    authorName = entry.author.name;
  }
  const authors = Array.isArray(entry.authors) ? entry.authors.filter(Boolean) : [];
  if (!authorName && authors.length) {
    [authorName] = authors;
  }

  let { title } = entry;
  if (!title) {
    title = entry.version ? `Versão ${entry.version}` : moment(key).format('LL');
  }

  return {
    key,
    version: entry.version || null,
    title,
    description: entry.description || null,
    authorName,
    authors: authors.length ? authors : [authorName].filter(Boolean),
    date: moment(entry.publishedAt || key),
    published: entry.status ? entry.status === 'published' : entry.visible !== false,
    status: entry.status || null,
    source: entry.source || null,
    jiraKeys: Array.isArray(entry.jiraKeys) ? entry.jiraKeys : [],
    generatedAt: entry.generatedAt || null,
    image: entry.imageUrl || null,
    hasNew: !entry.items && Boolean(entry.new),
    hasBugfix: !entry.items && Boolean(entry.bugfix),
    items,
  };
};
